<template>
    <div >
        <all-page :res_status="res_status"></all-page>
    </div>
</template>

<script>
    import allPage from "./all";
    export default {
        name: "passed",
        components: {
            allPage
        },
        data(){
            return{
                res_status:2
            }
        }
    }
</script>

<style scoped>

</style>
